import clsx from 'clsx'
import {useEffect, useState} from 'react'
import {PageSetting} from './TableStd'
const defaultPagination: PageSetting = {
  currentPage: 1,
  totalRow: 0,
  pageSize: 10,
}

export const PaginationStd = (props: {
  pageSetting?: PageSetting
  onPageChange?: (e: any, page: number) => void
  isLoading: boolean
}) => {
  type linkType = Array<{
    label: string
    disable: boolean
    active: boolean
    url: string | null
    page: number | null
  }>
  const [pageState, setPageState] = useState<PageSetting>(defaultPagination)
  const [links, setLinks] = useState<linkType>([buildPerPage(1, false)])
  const sizeBtw = 4
  useEffect(() => {
    if (props.pageSetting) setPageState(props.pageSetting)
  }, [props.pageSetting])

  function buildPerPage(i: number, disable: boolean, iterator?: 'BOF' | 'EOF') {
    let label = i.toString()
    let active = i === pageState.currentPage
    if (iterator && iterator === 'BOF') {
      i = i - 1
      label = '&laquo; Previous'
    }
    if (iterator && iterator === 'EOF') {
      i = i + 1
      label = 'Next &raquo;'
    }
    return {
      label: label,
      active: active,
      disable: disable,
      url: '/?page=' + i,
      page: i,
    }
  }
  useEffect(() => {
    const buildPages = () => {
      const link: any[] = []
      const pages = []
      const totalPage = Math.ceil(pageState.totalRow / pageState.pageSize)
      for (let i = 1; i < totalPage + 1; i++) {
        pages.push(i)
      }
      const pIndex = pageState.currentPage - 1
      const pStart = pIndex - sizeBtw > 0 ? pIndex - sizeBtw : 0
      const pEnd = pIndex + sizeBtw > totalPage ? totalPage : pIndex + sizeBtw
      const newSlice = pages.slice(pStart, pEnd)
      link.push(buildPerPage(pageState.currentPage, pStart <= 0, 'BOF'))
      newSlice.forEach((i) => {
        link.push(buildPerPage(i, false))
      })
      link.push(buildPerPage(pageState.currentPage, pEnd >= totalPage, 'EOF'))
      setLinks(link)
    }
    buildPages()
  }, [pageState])

  return (
    <div className='d-flex justify-content-between'>
      <div className=''>
        <span className='text-muted fw-bold fs-7'>Total {pageState.totalRow} records</span>
      </div>
      <div className=''>
        <div id='kt_table_users_paginate'>
          <ul className='pagination'>
            {links?.map((link) => (
              <li
                key={link.label}
                className={clsx('page-item', {
                  active: pageState.currentPage === link.page,
                  disabled: link.disable,
                  previous: link.label === '&laquo; Previous',
                  next: link.label === 'Next &raquo;',
                })}
              >
                <a
                  href='#/'
                  onClick={(e) => props.onPageChange?.(e, link.page ?? 1)}
                  className='page-link'
                  dangerouslySetInnerHTML={{__html: link.label}}
                  style={{cursor: 'pointer'}}
                />
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  )
}
